module.exports = __webpack_public_path__ + "static/img/SearchDetailDeath1.ebc86d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailDeath1.png
// module id = 716
// module chunks = 0